import { useSnackbarStore } from '@/store/snackbar';
import { publicBearerToken } from '@sonarwatch/portfolio-core';
import axios from 'axios';
import router from '@/router';

const errorInterceptor = (error: any) => {
  const store = useSnackbarStore();
  const status = error?.response?.status;
  let text = `Request failed. ${status ? `(${status})` : ''}`;
  if (status === 401) {
    text = 'Request failed, clear cache if it persists. (401)';
  } else if (status === 429) {
    text = 'Request failed, please wait. (429)';
  } else if (status === 404) {
    text = 'Not found.';
  } else if (status === 403) {
    text = 'Request failed, clear cache if it persists. (403)';
    const message: string | undefined = error?.response?.data?.message;
    if (message && message.toLocaleLowerCase().includes('turnstile')) {
      text = 'Request failed, proof of humanity required. (403)';
      router.push({ name: 'Captcha' });
    }
  }
  store.push({
    text,
    closable: true,
  });
  return Promise.reject(error);
};

const responseInterceptor = (response: any) => {
  return response;
};

const httpClientMain = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${import.meta.env.VITE_API_BEARER || publicBearerToken}`,
  },
});

httpClientMain.interceptors.response.use(responseInterceptor, errorInterceptor);
export { httpClientMain };
